import { parseSysDate } from "../plugins/formatting";
import { $t } from "../i18n";
import { formatNumber } from "../plugins/formatting";

export const CountAgrItems = [{ value: "min", text: $t("Min") }, { value: "max", text: $t("Max") }];
export const DateDirItems = [{ value: "before", text: $t("Before") }, { value: "after", text: $t("After") }];

export const getTaskColor = (colorRanges, item) => {
    for (let colorRange of colorRanges) {
        if (item.date >= colorRange.from && item.date <= colorRange.until)
            return colorRange.color;
    }
    return "";
};

export const getTaskColorDisp = (colorRanges, item) => {
    for (let colorRange of colorRanges) {
        if (item.date >= colorRange.from && item.date <= colorRange.until)
            return colorRange.disp;
    }
    return "";
};

export const getColorRangeDisp = (data, dateFields, short = false) => {
    let agr = CountAgrItems.find(x => x.value === data.count_agr).text;
    let unit = "";
    switch (data.count_unit) {
        case "week":
            unit = short ? $t("w") : (data.count === 1 ? $t("week") : $t("weeks"));
            break;
        case "day":
            unit = short ? $t("d") : (data.count === 1 ? $t("day") : $t("days"));
            break;
        default:
            unit = data.count_unit;
    }
    let dir = DateDirItems.find(x => x.value === data.date_dir).text.toLowerCase();
    let fld = dateFields.find(x => x.value === data.date_field);
    if (fld == null) {
        if (data.date_field === "end_date")
            fld = { text: $t("Due date") };
        else if (data.date_field === "start_date")
            fld = { text: $t("Start date") };
        else if (data.date_field === "event_date")
            fld = { text: $t("Internal date") };
    }
    return "{0} {1} {2} {3} {4}".format(agr, formatNumber(data.count), unit, dir, fld == null ? "-" : fld.text);
}

export const getColorRanges = (progress_steps, object, date_fields) => {
    let ret = [];
    for (let step of progress_steps) {
        let date_val = object[step.date_field];
        if (!date_val) continue;
        let count =
            (!step.count ? 0 : step.count) *
            (step.count_unit === "week" ? 7 : 1) *
            (step.date_dir === "after" ? 1 : -1);
        let field_date = parseSysDate(date_val);
        let calc_date = field_date.calcAddDays(count);

        if (step.date_dir === "before") {
            ret.push({
                from: (step.count_agr === "max" ? calc_date.formatSysDate() : null),
                until: (step.count_agr === "min" ? calc_date.formatSysDate() : field_date.formatSysDate()),
                color: step.color,
                disp: getColorRangeDisp(step, date_fields, true)
            });
        }
        else {
            ret.push({
                from: (step.count_agr === "max" ? field_date.formatSysDate() : calc_date.formatSysDate()),
                until: (step.count_agr === "min" ? null : calc_date.formatSysDate()),
                color: step.color,
                disp: getColorRangeDisp(step, date_fields, true)
            });
        }
    }
    for (let i = 0; i < ret.length; i++) {
        if (ret[i].from == null) {
            if (i > 0) ret[i].from = ret[i-1].until;
            else ret[i].from = new Date(1900, 0, 1).formatSysDate();
        }
        else if (ret[i].until == null) {
            if (i < ret.length - 1) ret[i].until = ret[i+1].from;
            else ret[i].until = parseSysDate(ret[i-1].from).calcAddYears(10).formatSysDate();
        }
    }
    /*for (let i = 0; i < ret.length; i++) {
        //console.log("AAAAAA", ret[i].from == null ? "-" : ret[i].from.formatDate(), ret[i].until == null ? "-" : ret[i].until.formatDate());
        console.log("AAAAAA", ret[i].from == null ? "-" : ret[i].from, ret[i].until == null ? "-" : ret[i].until);
    }*/
    return ret;
}